module.exports = __webpack_public_path__ + "img/award-2-min.0d79c1cb.png";